import { UserReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

const initialState: UserReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};

const userReducer = createReducer(initialState, {
  GGET_PROPERTY_DETAILS_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_PROPERTY_DETAILS_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },

  GET_PROPERTY_DETAILS_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = action.payload.data;
  },
});

export default userReducer;
